var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.440292 7.30658L2.98407 8.41994L10.3147 4.42113L5.89334 9.57898L12.2307 12.4644C12.339 12.5119 12.4573 12.5326 12.5753 12.5247C12.6934 12.5168 12.8078 12.4806 12.9089 12.4192C13.01 12.3578 13.0949 12.2729 13.1563 12.1718C13.2177 12.0706 13.2538 11.9562 13.2616 11.8381L13.9985 0.785582C14.0067 0.657656 13.9814 0.529796 13.9252 0.414586C13.869 0.299376 13.7838 0.200785 13.6779 0.128516C13.572 0.0562464 13.4491 0.0127889 13.3214 0.00241964C13.1936 -0.00794961 13.0653 0.0151267 12.9491 0.0693778L0.42187 5.96407C0.294084 6.02469 0.1864 6.12073 0.111624 6.24078C0.0368489 6.36083 -0.00187101 6.49982 6.95219e-05 6.64124C0.00201005 6.78265 0.0445292 6.92053 0.12257 7.03848C0.200612 7.15643 0.310891 7.24949 0.440292 7.30658ZM4.41954 14L7.93897 12.2935L4.41954 10.6518V14Z",
    fill: "#FCCA19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3ecae10bc3a2bbfde8e9fc22b1123d76.svg";
export { ForwardRef as ReactComponent };